import React from 'react';
import WaveEffect from '../template/WaveEffect';
import { formatDateLang } from '../../util/DataUtil';
import Link from "next/link";

const renderRows = (rowData = [], linkText = 'Learn more') => {
  return rowData.map((item, key) => {
    const authors = item?.field_authors || [];
    const url = item?.['url-alias'] || '#';
    const multipleAuthors = authors.length > 1;

    return (
      <Link key={`trending-index-${item?.['url-alias'] || item?.title || item?.nid || key}`} href={url} passHref>
        <a className="single-item">
          <div className="inner-item">
            <WaveEffect />
            <div>
              <p className="trending-item-title">{item?.title || ''}</p>
            </div>
            <div className="trending-item-middle">
              <div
                className={`info ${multipleAuthors ? 'multi-line' : 'single-line'}`}
              >
                {authors.length > 0 && (
                  <div className="authors">
                    {authors
                      .map((a) => a?.title || '')
                      .filter(Boolean)
                      .join(', ')}
                    {(item?.field_publish_date?.[0]?.value ||
                      item?.field_time_to_read?.[0]?.value) && (
                      <span className="divider">|</span>
                    )}
                  </div>
                )}

                {multipleAuthors ? (
                  <div className="publish-date new-line">
                    {item?.field_publish_date?.[0]?.value
                      ? formatDateLang(item?.field_publish_date?.[0]?.value)
                      : ''}
                    {item?.field_publish_date?.[0]?.value &&
                      item?.field_time_to_read?.[0]?.value && (
                        <span className="divider">|</span>
                      )}
                    <span className="time-to-read">
                      {item?.field_time_to_read?.[0]?.value || ''}
                    </span>
                  </div>
                ) : (
                  <>
                    {/*{authors.length > 0*/}
                    {/*    && <span className="divider">|</span>*/}
                    {/*}*/}
                    <div className="publish-date">
                      {item?.field_publish_date?.[0]?.value
                        ? formatDateLang(item?.field_publish_date?.[0]?.value)
                        : ''}
                      {item?.field_publish_date?.[0]?.value &&
                        item?.field_time_to_read?.[0]?.value && (
                          <span className="divider">|</span>
                        )}
                    </div>
                  </>
                )}
              </div>

              {!multipleAuthors && (
                <div className="time-to-read">
                  {item?.field_time_to_read?.[0]?.value || ''}
                </div>
              )}
              <div className="trending-item-bottom">
                <span className="learn-more">{linkText}</span>
              </div>
            </div>
          </div>
        </a>
      </Link>
    );
  });
};

export default function TemplateTrendingTopics({ data = {} }) {
  return (
    <div className="inner-containers">
      <div className="trending-topics">
        <p className="main-title">
          {data?.field_trending_topics_block_titl?.[0]?.value || ''}
        </p>

        <div>
          <p className="row-title">
            {data?.field_trending_topics_group_1_ti?.[0]?.value || ''}
          </p>
          <div className="container-trending">
            {renderRows(
              data?.field_trending_topics_group_1,
              data?.field_link_text[0]?.value
            )}
          </div>
        </div>

        <div>
          <p className="row-title">
            {data?.field_trending_topics_group_2_ti?.[0]?.value || ''}
          </p>
          <div className="container-trending">
            {renderRows(
              data?.field_trending_topics_group_2,
              data?.field_link_text[0]?.value
            )}
          </div>
        </div>

        <div>
          <p className="row-title">
            {data?.field_trending_topics_group_3_ti?.[0]?.value || ''}
          </p>
          <div className="container-trending">
            {renderRows(
              data?.field_trending_topics_group_3,
              data?.field_link_text[0]?.value
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
